import { useEffect } from 'react';

/**
 * Hook to dynamically set the body background color or gradient
 * This ensures the safe area (top/bottom) matches the page background
 * 
 * @param {string} color - The background to set
 *   Examples: 
 *   - Solid color: '#ffffff' or '#667eea'
 *   - Gradient: 'linear-gradient(135deg, #667eea, #764ba2)'
 */
export function useBodyBackground(color) {
  useEffect(() => {
    // Store the previous background
    const previousColor = document.body.style.background;
    const previousHtmlColor = document.documentElement.style.background;
    
    // Set the new background (works with both colors and gradients)
    document.body.style.background = color;
    document.documentElement.style.background = color;
    
    // Cleanup: restore previous background when component unmounts
    return () => {
      document.body.style.background = previousColor;
      document.documentElement.style.background = previousHtmlColor;
    };
  }, [color]);
}